import { Container, Tab, Tabs } from '@mui/material';
import React from 'react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { Props } from '../container';
import { EditContainer } from '../edit/container';
import { FeesContainer } from '../fees/container';
import { PortfoliosContainer } from '../portfolios/container';
import { ReportsContainer } from '../reports/container';
import { ReportSettingsContainer } from '../report-settings/container';
import { ClientPortalSettingsContainer } from '../clientPortal/container';

export const Templates = ({ hasDashEmail, canManageClientPortalSettings }: Props): JSX.Element => {
  const { pathname } = useLocation();
  const history = useHistory();

  const getValue = (): string => {
    if (pathname.startsWith('/templates/portfolios')) return '0';
    if (pathname.startsWith('/templates/email')) return '1';
    if (pathname.startsWith('/templates/report-settings')) return '2';
    if (pathname.startsWith('/templates/reports')) return '3';
    if (pathname.startsWith('/templates/fees')) return '4';
    if (pathname.startsWith('/templates/client-portal')) return '5';
    return '0';
  };

  return (
    <Container style={{ padding: '20px' }}>
      <Tabs value={getValue().toString()} TabIndicatorProps={{ style: { height: '4px' } }} style={{ padding: '0 0 10px' }}>
        <Tab onClick={() => history.replace(`/templates/portfolios`)} value="0" label="PORTFOLIO" />
        <Tab onClick={() => history.replace(`/templates/fees`)} value="4" label="FEES" />
        <Tab value="1" label="EMAIL" disabled={true} />
        <Tab onClick={() => history.replace(`/templates/report-settings`)} value="2" label="REPORT SETTINGS" />
        {canManageClientPortalSettings && <Tab onClick={() => history.replace(`/templates/client-portal`)} value="5" label="CLIENT PORTAL" />}
        {hasDashEmail && <Tab onClick={() => history.replace(`/templates/reports`)} value="3" label="REPORTS" />}
      </Tabs>
      <Switch>
        <Route exact path={`/templates`} render={() => <Redirect to={`templates/portfolios`} />} />
        <Route exact path={`/templates/fees/:afslId?`} component={FeesContainer} />
        <Route exact path={`/templates/portfolios/:afslId?`} component={PortfoliosContainer} />
        <Route path={`/templates/portfolios/:afslId/:id`} component={EditContainer} />
        <Route path={`/templates/report-settings/:afslId?`} component={ReportSettingsContainer} />
        {canManageClientPortalSettings && <Route path={`/templates/client-portal/:afslId?`} component={ClientPortalSettingsContainer} />}
        {hasDashEmail && <Route path="/templates/reports" component={ReportsContainer} />}
      </Switch>
    </Container>
  );
};
